<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>授权用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="姓名：">
        <el-input v-model="searchForm.name" placeholder="输入姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="searchForm.status" placeholder="请选择" clearable>
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增用户</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" min-width="100" align="center"></el-table-column>
      <el-table-column prop="phones" label="手机号" min-width="120" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row.status)" size="small">{{ statusLabel(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="expire_time" label="到期时间" width="160" align="center">
        <template slot-scope="scope">{{ scope.row.expire_time || '-' }}</template>
      </el-table-column>
      <el-table-column prop="remaining_times" label="剩余次数" width="100" align="center"></el-table-column>
      <el-table-column prop="device_id" label="设备ID" min-width="180" align="center">
        <template slot-scope="scope">{{ scope.row.device_id || '未绑定' }}</template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160" align="center"></el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="160" align="center"></el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      :total="total"
      :page.sync="pagination.currentPage"
      :limit.sync="pagination.pageSize"
      @pagination="fetchData"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="userForm" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phones">
          <el-input v-model="form.phones" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态" style="width:100%">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间" prop="expire_time">
          <el-date-picker v-model="form.expire_time" type="datetime" placeholder="选择到期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="剩余次数" prop="remaining_times">
          <el-input-number v-model="form.remaining_times" :min="0" style="width:100%"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getUserList, addUser, updateUser, deleteUser, bindDevice, unbindDevice } from '@/api/authorizedUser'
import Pagination from '@/components/Pagination'

export default {
  name: 'AuthorizedUser',
  components: { Pagination },
  data() {
    return {
      loading: false,
      submitLoading: false,
      bindLoading: false,
      searchForm: { name: '', status: null },
      tableData: [],
      total: 0,
      pagination: { currentPage: 1, pageSize: 10 },
      dialogVisible: false,
      dialogTitle: '',
      bindDialogVisible: false,
      bindForm: { id: null, device_id: '' },
      form: {
        id: null,
        name: '',
        phones: '',
        status: 0,
        expire_time: null,
        remaining_times: 0
      },
      statusOptions: [
        { value: -1, label: '封禁' },
        { value: 0, label: '按次付费' },
        { value: 1, label: '包月' },
        { value: 2, label: '季付' },
        { value: 3, label: '半年付' },
        { value: 99999, label: '无限制' }
      ],
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phones: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    console.log('FetchData 被执行了')
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        name: this.searchForm.name || undefined,
        status: this.searchForm.status !== null && this.searchForm.status !== '' ? this.searchForm.status : undefined
      }
      getUserList(params).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.rows
          this.total = res.data.total
        } else{
          this.$message.error(res.msg || '查询失败')
        }
      }).catch(() => this.$message.error('网络异常')).finally(() => this.loading = false)
    },
    handleSearch() { this.pagination.currentPage = 1; this.fetchData() },
    handleAdd() {
      this.dialogTitle = '新增用户'
      this.form = { id: null, name: '', phones: '', status: 0, expire_time: null, remaining_times: 0 }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑用户'
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm(`确定删除用户“${row.name}”吗？`, '提示', { type: 'warning' }).then(() => {
        deleteUser({ id: row.id }).then(res => {
          if (res.code === 0) this.$message.success('删除成功'), this.fetchData()
          else this.$message.error(res.msg || '删除失败')
        }).catch(() => this.$message.error('网络异常'))
      }).catch(() => {})
    },
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const api = this.form.id ? updateUser : addUser
        api(this.form).then(res => {
          if (res.code === 0) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.fetchData()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        }).catch(() => this.$message.error('网络异常')).finally(() => this.submitLoading = false)
      })
    },
    resetForm() { this.$refs.userForm && this.$refs.userForm.resetFields() },
    statusLabel(status) {
      const found = this.statusOptions.find(item => item.value === status)
      return found ? found.label : '未知'
    },
    statusTagType(status) {
      if (status === -1) return 'danger'
      if (status === 99999) return 'success'
      return 'info'
    },
    handleBindDevice(row) {
      this.bindForm = { id: row.id, device_id: '' }
      this.bindDialogVisible = true
    },
    handleUnbindDevice(row) {
      this.$confirm('确定解绑设备吗？', '提示', { type: 'warning' }).then(() => {
        unbindDevice({ id: row.id }).then(res => {
          if (res.code === 0) this.$message.success('解绑成功'), this.fetchData()
          else this.$message.error(res.msg || '解绑失败')
        }).catch(() => this.$message.error('网络异常'))
      }).catch(() => {})
    },
    submitBindDevice() {
      if (!this.bindForm.device_id) return this.$message.warning('请输入设备ID')
      this.bindLoading = true
      bindDevice({ id: this.bindForm.id, device_id: this.bindForm.device_id }).then(res => {
        if (res.code === 0) {
          this.$message.success('绑定成功')
          this.bindDialogVisible = false
          this.fetchData()
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      }).catch(() => this.$message.error('网络异常')).finally(() => this.bindLoading = false)
    }
  }
}
</script>

<style scoped>
.user-search { margin-top: 20px; margin-bottom: 20px; }
</style>


// WEBPACK FOOTER //
// src/views/authorizedUser/AuthorizedUser.vue